export default "__VITE_ASSET__M5_DqONs__"